// Public global-stats + knowledge-tree bindings (/stats/*). These endpoints are
// auth-free on the backend; we leave the default bearer attached (harmless under
// /app where the user is logged in).
import { api } from "./client";
import type { GlobalStats, TreeNode, TreeResponse } from "./stats-types";

export function getGlobalStats(region?: string, country?: string): Promise<GlobalStats> {
  return api.get<GlobalStats>("/stats/global", { query: { region, country } });
}

export function getStatsTree(region?: string): Promise<TreeResponse> {
  return api.get<TreeResponse>("/stats/tree", { query: { region } });
}

export function getStatsTreeNode(nodeId: string, region?: string): Promise<TreeNode> {
  return api.get<TreeNode>(`/stats/tree/${encodeURIComponent(nodeId)}`, { query: { region } });
}
